import React, { useEffect, useMemo, useState } from "react";
import { getRouteLoad } from "../../../api/analyticsApi";
import WidgetPanel from "../../ui/WidgetPanel";
import KeyValueGrid from "../../ui/KeyValueGrid";
// Unknown renders "—", never 0 (metricValue). safePct(null) → "—", not "0%".
import { num, safePct } from "../metricValue";
import "./AnalyticsShared.css";

const dash = (v) => (v === null || v === undefined ? "—" : v);

export default function AnalyticsRouteLoad() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [payload, setPayload] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      setError("");
      try {
        const res = await getRouteLoad({ days: 14 });
        if (!mounted) return;
        setPayload(res?.data || null);
      } catch (e) {
        if (!mounted) return;
        setError(e?.message || "Route load unavailable.");
        setPayload(null);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const rows = useMemo(() => {
    const list = Array.isArray(payload?.rows) ? payload.rows : [];
    return list.slice(0, 50).map((r) => ({
      route_id: r.route_id,
      route_date: r.route_date,
      technician_name: r.technician_name || "Unassigned",
      scheduled_jobs: num(r.scheduled_jobs),
      capacity_slots: num(r.capacity_slots),
      load_rate: num(r.load_rate),
      average_distance: num(r.average_distance),
      distance_score: num(r.distance_score),
      title: r.title || r.group_title || "",
    }));
  }, [payload]);

  const supported = payload?.supported !== false;

  return (
    <div className="analytics-page-shell">
      <header className="analytics-page-head">
        <div>
          <p className="eyebrow">Analytics</p>
          <h1>Route Load</h1>
          <span>Shows route capacity pressure. Uses FieldRoutes routes when available.</span>
        </div>
      </header>

      {!supported ? (
        <div className="analytics-warn">Route analytics not enabled for this tenant yet.</div>
      ) : null}
      {error ? <div className="analytics-warn">{error}</div> : null}

      <WidgetPanel title="Routes" subtitle={payload?.date_from ? `${payload.date_from} → ${payload.date_to}` : "Last 14 days"}>
        {loading ? (
          <div className="analytics-empty">Loading…</div>
        ) : !rows.length ? (
          <div className="analytics-empty">No routes found.</div>
        ) : (
          <div className="analytics-table">
            <div className="analytics-table-head">
              <span>Date</span>
              <span>Tech</span>
              <span>Jobs</span>
              <span>Cap</span>
              <span>Load</span>
              <span>Score</span>
            </div>
            {rows.map((r) => (
              <div key={`${r.route_id}-${r.route_date}`} className="analytics-table-row">
                <strong>{r.route_date || "—"}</strong>
                <span title={r.technician_name}>{r.technician_name}</span>
                <span>{dash(r.scheduled_jobs)}</span>
                <span>{dash(r.capacity_slots)}</span>
                <span>{safePct(r.load_rate)}</span>
                <span>{dash(r.distance_score)}</span>
              </div>
            ))}
          </div>
        )}
      </WidgetPanel>

      <KeyValueGrid title="Raw Payload" data={payload || {}} />
    </div>
  );
}

